import React from 'react';
//import ReactDOM from 'react-dom/client';
import { createRoot } from 'react-dom/client'
import App from './App';
import ContextProvider from './context/ContextProvider';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@emotion/react';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { theme } from './themes/theme';

import './index.css'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowsFocus: false,   // Para que no se recarguen los datos cada vez que la ventana se enfoca
            retry: 2,                       // Numero de veces que se intenta hacer un fetch de los datos
            staleTime: Infinity,            // Hace que se carguen los datos una sola vez y cada que se invaliden los datos con invalidateQueries
        },
    },
})


createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <QueryClientProvider client={queryClient}>

                <ContextProvider>
                    <BrowserRouter >
                        <Routes >
                            <Route path="/*" element={<App />} />
                        </Routes>
                    </BrowserRouter>
                </ContextProvider>
            </QueryClientProvider>

        </ThemeProvider>
    </React.StrictMode>
);

